<template>
    <div>
        <modal size="lg" :id="iframeModalId" title="Message Content">
            <iframe class="iframe-content w-100 h-100" :src="iframeLink" />
        </modal>
        <modal size="lg" :id="notesModalId" title="Note">
            <div>
              <div v-for="(line, index) in notes" :key="index">{{ line }}<br></div>
            </div>
        </modal>        
        <span v-if="body">{{ body }}</span>
        <a
            class="text-primary cursor-pointer"
            v-if="iframeLink"
            @click="$bvModal.show(iframeModalId)"
            >Show Content</a
        >
        <a
            class="text-primary cursor-pointer"
            v-if="notes"
            @click="$bvModal.show(notesModalId)"
            >Show Content</a
        >        
    </div>
</template>

<script>
import modal from '../../../generic/modal/modal.vue';
export default {
    components: { modal },
    computed: {
        iframeModalId() {
            return 'message-content-modal' + this.params.data.id;
        },
        notesModalId() {
            return 'notes-content-modal' + this.params.data.id;
        },        
        body() {
            return this.params && this.params.data.body;
        },
        notes() {
            return this.params && this.params.data.notes && this.params.data.notes.split('\n');
        },        
        iframeLink() {
            return this.params && this.params.data.communication_link;
        },
    },
};
</script>

<style scoped>
.iframe-content {
    border: none;
}
</style>